export const setPropertyData = (model, setModel, ele, property, locale=false, language=null , specification=false) =>{
    let newData = Object.assign({}, model);

    if(locale){
        let existsLocales = newData.locales.filter((i) => {
            return i.locale === language;
        })
        if(existsLocales.length){
            existsLocales[0][ele.target.name] = ele.target.value;
        }else{
            let newLocale = {'locale': language };
            newLocale[ele.target.name] = ele.target.value;
            newData.locales.push(newLocale);
        }
    }else if(specification){
        let specKey = ele.target.name;
        let existsObj = newData.specifications.filter((i) => {
            return i.key == specKey; // Use == for loose equality to handle string/number mismatch
        })
        
        if(existsObj.length){
            existsObj[0]['value'] = ele.target.value;
        }else{
            newData.specifications.push({'key': specKey ,'value': ele.target.value});
        }
    }else{
        if (ele.target.name === 'image') {
            if(ele.target.files.length){
                newData['image'] = ele.target.files[0];
            }
        }else if(ele.target.name === 'facility'){
            let facilityId = Number(ele.target.value);
            
            if(ele.target.checked) {
                // Adding facility - make sure it's not already there
                if(!newData.facilities.includes(facilityId)) {
                    newData.facilities.push(facilityId);
                }
            } else {
                // Removing facility
                let index = newData.facilities.indexOf(facilityId);
                if(index > -1) {
                    newData.facilities.splice(index, 1);
                }
            }
        }else if(ele.target.name === 'status' || ele.target.name === 'featured'){
            newData[property] = ele.target.checked ? 1 : 0;
        }else{
            newData[property] = ele.target.value;
        }
    }

    setModel(newData);
}